import React from 'react';

import { CenterCellContainer } from './CenterCellContainer';
import i18n from 'FRONTEND/utils/i18n';

export const CellAge = ({ age }: { age: { value: number, unit: string } | null | undefined }) => {
  // Seems like age on consultations is currently bugged, patient age value/unit are not being sent.
  // Copied this function from datatables.js anyway for when it gets resolved.
  if (age === null || age === undefined) {
    return '';
  }
  const ageUnits = {
    years: i18n._('y'),
    months: i18n._('m'),
    days: i18n._('d'),
  };
  return <CenterCellContainer>{`${age.value}${ageUnits[age.unit] || ''}`}</CenterCellContainer>;
};
